import { useContext } from 'react';
import { AlmaXStudentsRefreshContext } from './AllAlmaXStudents';

export default function useAlmaXStudentsRefresh() {
  const context = useContext(AlmaXStudentsRefreshContext);
  if (!context) {
    console.warn('useAlmaXStudentsRefresh must be used within AlmaXStudentsRefreshContext');
    return { refreshGridData: () => {} };
  }
  return context;
}
